import { createContext, PropsWithChildren, useCallback, useContext, useState } from "react"
import { api } from "../../contracts";
import { ExamResolution } from "../../contracts/examResolution/dto";
import { useCourse } from "../course";

type ContextExamResolutionData = {
    list: ExamResolution[],
    getList: () => Promise<ExamResolution[]>
}

const DEFAULT: ContextExamResolutionData = {
    list: [],
    getList: () => Promise.resolve([])
}

const ExamResolutionContext = createContext(DEFAULT);

export const ExamResolutionProvider = ({ children }: PropsWithChildren<any>) => {
    const { type } = useCourse();
    const [list, setList] = useState<ExamResolution[]>([]);

    const getList = useCallback(async () => {
        const items = await api.examResolution.getList(type);
        setList(items);

        return items;
    }, [type]);

    return <ExamResolutionContext.Provider
        value={{
            list,
            getList
        }}>
        {children}
    </ExamResolutionContext.Provider>
}

export const useExamResolution = (): ContextExamResolutionData => {
    const context = useContext(ExamResolutionContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}